export default {
  loadAuthToken({commit}) {
    const authToken = localStorage.getItem("authToken")

    if (!authToken) return

    commit('SET_AUTH_TOKEN', {authToken: authToken})
  }

}



// WEBPACK FOOTER //
// ./src/store/actions.js